import { apiRequestPage, type PaginationMeta } from './client';

/**
 * FEAT-013 — reading the security log.
 *
 * Read-only, and there is no write function here because there is no write
 * endpoint: the log is append-only and its entries are produced by the modules
 * that cause them. An API that let a caller author an entry would let them
 * author an alibi.
 */

export interface AuditEvent {
  id: string;
  occurred_at: string;
  actor_id: string | null;
  /** Null for an unauthenticated event — a failed sign-in, or an OAuth callback. */
  actor_name: string | null;
  /** Snapshot at the time of the event, so it survives a role change (REQ-077). */
  actor_role: string | null;
  event: string;
  target_type: string | null;
  target_id: string | null;
  ip: string | null;
  user_agent: string | null;
}

export interface AuditQuery {
  page: number;
  pageSize: number;
  from?: string;
  to?: string;
  /** Free text over the event description and the actor's name. */
  q?: string;
  /** Newest first unless asked otherwise. A closed set, not a column name. */
  sort?: 'newest' | 'oldest';
}

export function listAuditEvents(
  query: AuditQuery,
): Promise<{ items: AuditEvent[]; meta: PaginationMeta }> {
  return apiRequestPage<AuditEvent>('/audit', {
    query: {
      page: query.page,
      page_size: query.pageSize,
      ...(query.from ? { from: query.from } : {}),
      ...(query.to ? { to: query.to } : {}),
      ...(query.q ? { q: query.q } : {}),
      ...(query.sort ? { sort: query.sort } : {}),
    },
  });
}
